import React from 'react';
import I18n from 'i18n-js';
import verifyYourPickupAddr from 'public/images/verify-your-pickup-address.svg';
import styles from './verify-pickup-matched-onboarding.less';

const VerifyPickupMatchedOnboarding = () => (
  <div className={styles.verifyPickupMatchedOnboarding}>
    <img
      className={styles.verifyYourPickupAddr}
      src={verifyYourPickupAddr}
      alt={'verify-your-pickup-address'}
    />
    <div className={styles.title}>
      {I18n.t('shopify.home.verifyPickupMatchedOnboarding.title')}
    </div>
    <div className={styles.text}>
      {I18n.t('shopify.home.verifyPickupMatchedOnboarding.text')}
    </div>
  </div>
);

export default VerifyPickupMatchedOnboarding;
